import React from 'react';

import { Text } from '@wix/wix-ui-tpa';

export const MinimalTemplatePayload: React.FC<{
  text?: null | string;
  iconUrl?: null | string;
}> = ({ text, iconUrl }) => {
  return <Text>{text}</Text>;
};
